"use client";

import React from "react";
import currency from "currency.js";

import { useCookie } from "react-use";

import useSizeUnitStore from "@/stores/sizeUnit";
import { useTranslations } from "next-intl";

const useSizeUnit = () => {
  const t = useTranslations();
  const [value, updateCookie, deleteCookie] = useCookie("sizeUnit");

  const { currentSizeUnit, set } = useSizeUnitStore();

  React.useEffect(() => {
    set({ currentSizeUnit: value ?? "sqft" });

    if (!value) {
      updateCookie("sqft", {
        expires: Date.now() + 365 * 24 * 60 * 60 * 1000,
      });
    }
  }, [updateCookie, value, set]);

  const getUnitAwareAmount = React.useCallback(
    (amount) => {
      if (currentSizeUnit === "sqm") {
        return parseFloat(amount) / 0.09290304;
      }

      return parseFloat(amount);
    },
    [currentSizeUnit],
  );

  const getUnitAwareSize = React.useCallback(
    (size) => {
      if (currentSizeUnit === "sqm") {
        return parseFloat(size) * 0.09290304;
      }

      return parseFloat(size);
    },
    [currentSizeUnit],
  );

  const format = React.useCallback(
    (val = null, params = { showUnit: true }) => {
      if (!currentSizeUnit || !val) {
        return null;
      }

      return `${getUnitAwareSize(val)
        .toFixed(1)
        .replace(/[.,]0$/, "")}${
        params.showUnit ? " " + t(`common.size_unit.${currentSizeUnit}`) : ""
      }`;
    },
    [currentSizeUnit, getUnitAwareSize, t],
  );

  return {
    getUnitAwareAmount,
    getUnitAwareSize,
    currentSizeUnit,
    updateCurrentSizeUnit: (val) => {
      // clearing cache
      // remove();
      updateCookie(val);
    },
    format,
  };
};

export default useSizeUnit;
